var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFsDndSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5498e0",
    fillRule: "evenodd",
    d: "M35.4 19v5.1H15V19zm-1.275 1.912h-1.276v1.275h1.275zm-2.55 0H30.3v1.275h1.275zm-2.55 0h-1.276v1.275h1.275z",
    transform: "translate(-5 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279c5",
    fillRule: "evenodd",
    d: "M35.4 27v5.1H15V27zm-1.275 1.912h-1.276v1.275h1.275zm-2.55 0H30.3v1.275h1.275zm-2.55 0h-1.276v1.275h1.275z",
    transform: "translate(-5 -6.769)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsDndSmall);
export default __webpack_public_path__ + "static/media/fs-dnd-small.009f15f714aec65957ebc837da76bd90.svg";
export { ForwardRef as ReactComponent };